import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { PASSWORD, USERNAME } from "./consts";
import useLogin from "./useLogin";
import coverImg from "@/assets/loginCover.svg";
import { UserIcon } from "lucide-react";

const Login = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    onEyeIconClick,
    isPassword,
    Icon,
    isLoginPending,
    onForgotClick,
  } = useLogin();
  const { errors } = form.formState;

  return (
    <div className="flex md:flex-row w-full h-[100vh]">
      <div className="hidden md:flex flex-col justify-center items-center w-1/2 bg-blue-900 text-white p-8 relative">
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <img
          src={coverImg}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative text-center z-10">
          <h1 className="text-[30px] lg:text-[54px] font-bold">
            Welcome to Communacam
          </h1>
          <p className="mt-2 text-lg">Please sign in to continue</p>
        </div>
      </div>
      <div className="w-full md:w-1/2 bg-gray-100 flex flex-col justify-center items-center p-8">
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Card className="w-full lg:w-[400px]">
              <CardHeader className="my-[20px]">
                <CardTitle className="text-center font-[500] text-[24px]">
                  Login
                </CardTitle>
                <span className="text-[14px] text-g-400 text-center">
                  Access to explore more
                </span>
              </CardHeader>
              <CardContent>
                <div className="flex flex-col gap-5">
                  <div>
                    <label className="text-[14px] font-[400]">Username</label>
                    <FormInput
                      name={USERNAME}
                      control={form.control}
                      placeholder="Please enter"
                      error={errors[USERNAME]?.message}
                      isRequired={requiredFields.includes(USERNAME)}
                      endIcon={<UserIcon className="h-4 w-4" />}
                    />
                  </div>
                  <div>
                    <label className="text-[14px] font-[400]">Password</label>
                    <FormInput
                      name={PASSWORD}
                      control={form.control}
                      placeholder="Please enter"
                      error={errors[PASSWORD]?.message}
                      isRequired={requiredFields.includes(PASSWORD)}
                      type={isPassword ? "password" : "text"}
                      endIcon={
                        <Icon className="h-4 w-4" onClick={onEyeIconClick} />
                      }
                    />
                  </div>
                  <div className="flex justify-end">
                    <Button
                      type="button"
                      variant="link"
                      className="text-[14px] text-primary text-end p-0 m-0 h-[20px] no-underline font-[400]"
                      onClick={onForgotClick}
                    >
                      Forgot Password?
                    </Button>
                  </div>
                </div>
              </CardContent>
              <CardFooter>
                <Button
                  type="submit"
                  className="w-full"
                  disabled={isLoginPending}
                >
                  {isLoginPending ? <Loader variant="secondary" /> : ""} Login
                </Button>
              </CardFooter>
            </Card>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default Login;
